import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useCapturedUrlParams from '@/hooks/useCapturedUrlParams';
import { holdCredentials, splitSensitiveParams } from '@/utils/sensitiveUrl';

/**
 * DesktopLoginRedirect Component
 *
 * Handles the /desktop-login route and redirects to /log-in, carrying the
 * magic-link token from the email.
 *
 * The token is forwarded through the held-credentials store, NOT the URL:
 * putting it back into /log-in?token=... would re-expose it to every
 * third-party tag that reads the address bar (order 7170).
 */
const DesktopLoginRedirect = () => {
  const navigate = useNavigate();
  const searchParams = useCapturedUrlParams();

  useEffect(() => {
    const { kept, held } = splitSensitiveParams(searchParams.toString());
    if (held) holdCredentials('/log-in', held);
    navigate(kept ? `/log-in?${kept}` : '/log-in', { replace: true });
  }, [navigate, searchParams]);

  // Return null or a loading state while redirecting
  return null;
};

export default DesktopLoginRedirect;
